// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const Notification = t.struct({
    shortText: t.String,
    title: t.String,
    url: t.String
}, {
    name: 'Notification',
    strict: true
});

export const getDefaultState = () => new Notification({
    shortText: '',
    title: '',
    url: ''
});

export default Notification;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/notification.js